import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-quote", () => {
    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-quote quote="Lorem ipsum dolor sit amet" source="Lorem Ipsum"> </ux-quote>`);
        const el = await page.find("ux-quote");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should match to snapshot with image", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-quote 
                quote="Lorem ipsum dolor sit amet" 
                source="Lorem Ipsum" 
                image="../../../resources/mock-assets/images/trulaser-station-7000.jpg"> 
            </ux-quote>`
        );
        const el = await page.find("ux-quote");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-quote></ux-quote>`);
    });
});
